import { Eye, MessageSquare, Pencil, Target, Trash2 } from 'lucide-react'

import { Badge } from '@/shared/components/ui/badge'
import { Button } from '@/shared/components/ui/button'

export const salesColumns = (
  onEdit,
  onDelete,
  onMessage,
  unreadCounts = {},
  onAssignTarget,
  onViewTargets,
) => [
  {
    id: 'name',
    header: 'Name',
    accessorKey: 'name',
  },
  {
    id: 'email',
    header: 'Email',
    accessorKey: 'email',
  },
  {
    id: 'phoneNumber',
    header: 'Phone Number',
    accessorKey: 'phoneNumber',
  },
  {
    id: 'role',
    header: 'Role',
    cell: (row) => <Badge variant="outline">{row.role}</Badge>,
  },

  {
    id: 'actions',
    header: 'Actions',
    cell: (row) => {
      const personId = String(row._id || row.id || '')
      const unreadCount = Number(unreadCounts?.[personId] || 0)

      return (
        <div className="flex items-center gap-2">
          {onViewTargets && (
            <Button
              variant="outline"
              size="icon"
              className="h-9 w-9 rounded-full border-black/[0.08] hover:bg-indigo-50 hover:text-indigo-600 hover:border-indigo-200 transition-colors"
              title="View Monthly Targets & Achievements"
              aria-label="View Monthly Targets & Achievements"
              onClick={() => onViewTargets(row)}
            >
              <Eye className="h-4 w-4 text-slate-700 hover:text-indigo-600" />
            </Button>
          )}

          {onAssignTarget && (
            <Button
              variant="outline"
              size="icon"
              className="h-9 w-9 rounded-full border-black/[0.08] hover:bg-emerald-50 hover:text-emerald-600 hover:border-emerald-200 transition-colors"
              title="Assign Target"
              aria-label="Assign Target"
              onClick={() => onAssignTarget(row)}
            >
              <Target className="h-4 w-4 text-slate-700 hover:text-emerald-600" />
            </Button>
          )}

          {onMessage && (
            <div className="relative">
              <Button
                variant="outline"
                size="icon"
                className="h-9 w-9 rounded-full border-black/[0.08] hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                title="Message"
                aria-label="Message"
                onClick={() => onMessage(row)}
              >
                <MessageSquare className="h-4 w-4 text-slate-700 hover:text-indigo-600" />
              </Button>
              {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 flex min-w-4 h-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white shadow-xs pointer-events-none animate-in fade-in">
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </div>
          )}

          <Button
            variant="outline"
            size="icon"
            className="h-9 w-9 rounded-full border-black/[0.08]"
            title="Edit"
            aria-label="Edit"
            onClick={() => onEdit(row)}
          >
            <Pencil className="h-4 w-4" />
          </Button>

          <Button
            variant="destructive"
            size="icon"
            className="h-9 w-9 rounded-full bg-red-600 hover:bg-red-700"
            title="Delete"
            aria-label="Delete"
            onClick={() => onDelete(row)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      )
    },
  },
]
